export const MEDIA = {
  HERO_HOME: {
    src: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=2000",
    alt: "Abstract premium background for a professional services authority landing page",
    title: "Hero Background",
    caption: ""
  },
  LOGO_EMAIL: {
    src: "",
    alt: "BPA Solutions Logo",
    title: "BPA Solutions",
    caption: ""
  },
  DEMO_1: {
    src: "https://images.unsplash.com/photo-1576765608535-5f04d1e3f289?auto=format&fit=crop&q=80&w=800",
    alt: "NDIS Disability Support website preview for NextStep Support Services",
    title: "NextStep Support Services",
    caption: "NDIS Disability Support"
  },
  DEMO_2: {
    src: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&q=80&w=800",
    alt: "Accounting & Advisory website preview for Swan River Accounting",
    title: "Swan River Accounting",
    caption: "Accounting & Advisory"
  },
  DEMO_3: {
    src: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?auto=format&fit=crop&q=80&w=800",
    alt: "Driving School website preview for Adelaide Driving Academy",
    title: "Adelaide Driving Academy",
    caption: "Driving School"
  },
  DEMO_4: {
    src: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&q=80&w=800",
    alt: "Family Day Care website preview for SafeNest",
    title: "SafeNest Family Day Care",
    caption: "Family Day Care"
  },
  DEMO_5: {
    src: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&q=80&w=800",
    alt: "Law Firm website preview for Lexington Legal Group",
    title: "Lexington Legal Group",
    caption: "Law Firm"
  },
  DEMO_6: {
    src: "https://images.unsplash.com/photo-1560066984-138dadb4c035?auto=format&fit=crop&q=80&w=800",
    alt: "Hair Studio website preview for Luxe Locks Studio",
    title: "Luxe Locks Studio",
    caption: "Hair Studio"
  },
  DEMO_7: {
    src: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&q=80&w=800",
    alt: "Medical Practice website preview for Serenity Medical Group",
    title: "Serenity Medical Group",
    caption: "Medical Practice"
  },
  DEMO_8: {
    src: "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?auto=format&fit=crop&q=80&w=800",
    alt: "Barber Shop website preview for Sharp Edges",
    title: "Sharp Edges",
    caption: "Barber Shop"
  }
};